'use strict';

// Webpack incorpora el mismo núcleo puro que ejecuta Node en el backend.
module.exports = require('../../../server/lib/form28_geometry_core');
